import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLanguageContext } from "../../../../context/LanguageContext";
import Select from "../Select";
import {
  StyledMultiSelect,
  StyledMultiSelectActions,
  StyledMultiSelectClear,
  StyledMultiSelectValue,
  StyledMultiSelectValues,
} from "./MultiSelectStyles";
import { faCaretDown, faXmark } from "@fortawesome/free-solid-svg-icons";

function MultiSelectView({
  availableOptions,
  selectedOptions,
  onAdd,
  onRemove,
  onClear,
  onKeyDown,
  title,
  placeholder,
  disabled,
  searchable,
  unfocusOnChange,
  sort,
}) {
  const { translate } = useLanguageContext();

  return (
    <Select
      title={title}
      placeholder={placeholder}
      disabled={disabled}
      options={availableOptions}
      onChange={onAdd}
      onKeyDown={onKeyDown}
      searchable={searchable}
      unfocusOnChange={unfocusOnChange}
      sort={sort}
      hideCaret={true}
      valueVisual={() => (
        <StyledMultiSelect>
          {selectedOptions.length > 0 ? (
            <StyledMultiSelectValues>
              {selectedOptions.map((option) => (
                <StyledMultiSelectValue
                  key={option.value}
                  type="button"
                  tabIndex={-1}
                  onClick={(e) => onRemove(e, option.value)}
                >
                  {option.label}
                </StyledMultiSelectValue>
              ))}
            </StyledMultiSelectValues>
          ) : (
            placeholder ?? translate("eva.main.general.select")
          )}

          <StyledMultiSelectActions>
            {selectedOptions.length > 0 && (
              <StyledMultiSelectClear
                icon={faXmark}
                size="sm"
                onClick={onClear}
                title={translate("eva.main.general.clear_all")}
              />
            )}

            <FontAwesomeIcon icon={faCaretDown} size="sm" />
          </StyledMultiSelectActions>
        </StyledMultiSelect>
      )}
    />
  );
}

export default MultiSelectView;
